import {SidebarMenuItem} from '../../../../Kpi/components/sidebar/sidebar-menu/SidebarMenuItem'

const SidebarMenuMain = () => {
  return (
    <>
      <SidebarMenuItem
        to='/admin/cielo-merchants'
        icon='shield-tick'
        title='Cielo Merchants'
        fontIcon='bi-credit-card'
      />
      <SidebarMenuItem
        to='/admin/contract-terms'
        icon='document'
        title='Termos de Consentimento'
        fontIcon='bi-file-earmark-text'
      />
      <SidebarMenuItem
        to='/admin/products'
        icon='delivery-2'
        title='Produtos'
        fontIcon='bi-archive'
      />
      <SidebarMenuItem
        to='/admin/categories'
        icon='category'
        title='Categorias de Produto'
        fontIcon='bi-tags'
      />
      <SidebarMenuItem
        to='/admin/machines'
        icon='technology-2'
        title='Máquinas'
        fontIcon='bi-cpu'
      />
      <SidebarMenuItem
        to='/admin/franchises'
        icon='shop'
        title='Franquias'
        fontIcon='bi-shop'
      />
      <SidebarMenuItem
        to='/admin/rooms'
        icon='lots-shopping'
        title='Salas'
        fontIcon='bi-door-open'
      />
      <SidebarMenuItem
        to='/admin/payment-options'
        icon='two-credit-cart'
        title='Formas de Pagamento'
        fontIcon='bi-credit-card-2-front'
      />
      <SidebarMenuItem
        to='/admin/groups'
        icon='people'
        title='Grupos'
        fontIcon='bi-people'
      />
      <SidebarMenuItem
        to='/admin/users'
        icon='user'
        title='Usuários'
        fontIcon='bi-person'
      />
    </>
  )
}

export {SidebarMenuMain}
